import { CtSelectControlValue } from "@ctsolution/ct-framework";
import { CustomCompanySetupEnum } from "../../components/company/company-edit/company-edit.component";

export class CTConfigurationModel {

  visible: boolean = true;
  customCompanySetup: CustomCompanySetupEnum = CustomCompanySetupEnum.BASE;
  customCompanyTemplate = 'company-information-model.json';
  label?: string;
  type?: number;
  cols: Array<string> = [];
  visibleWorkOrder: boolean = true;
  doubleClickOpenDetail: boolean = false;
  expanded: boolean = false;
  formatPrice: number = 2;
  formatNumber: number = 2;
  multiCheckBoxTable: boolean = false;
  bypassLeadStatus: boolean = false;
  useDefaultVAT: boolean = false;
  visibleHintRowWorkOrder: boolean = true;
  cloneRowEnabled: boolean = true;

  showTotalRow: boolean = false;
  legendsItem: Array<any> = [
    { color: '#A82A26', label: 'Presentation Call', description: 'Appuntamento di presentazione ufficiale con cliente o prospect' },
    { color: '#2196F3', label: 'Appuntamento', description: 'Appuntamento con potenziale cliente' },
    { color: '#E1C11F', label: 'Mail', description: 'Mail in attesa di essere inviata' },
    { color: '#06820D', label: 'Commessa - Inizio lavori', description: 'Avvio operativo di una commessa o progetto' },
    { color: '#780E82', label: 'Offerta - Da inviare', description: 'Offerta pronta, in attesa di essere inviata' },
    { color: '#FF9800', label: 'Call', description: 'Telefonata per seguire una trattativa già avviata' },
    { color: '#FF148D', label: 'Lead - Attività proattiva', description: 'Iniziativa autonoma verso nuovi lead' },
    { color: '#12CED5', label: 'Offerta - In trattativa', description: 'Offerta inviata, in attesa di risposta o trattativa attiva' },
    { color: '#884916', label: 'Commessa - Verifica stato', description: 'Controllo avanzamento lavori su commessa' },
    { color: '#44D130', label: 'Proattiva', description: 'Promemoria di proattività' },
    { color: '#008080', label: 'Follow up', description: 'Controllo stato avanzamento' },
    { color: '#000000', label: 'Kick Off', description: 'Kick off con cliente o interno' }
  ];

  visibleFields: string[] = [
    'DisplayName',
    'ReferenceName',
    'FiscalCode',
    'VAT',
    'Places'
  ];

  valueOptions: any | null = null;

  constructor() { }

  public static create = (): CTConfigurationModel => new CTConfigurationModel();

  setVisible(value: boolean): CTConfigurationModel {
    this.visible = value;
    return this;
  }

  setLabel(value: string): CTConfigurationModel {

    this.label = value;
    return this;

  }

  setType(value: number): CTConfigurationModel {
    this.type = value;
    return this;
  }

  setCols(value: Array<string>): CTConfigurationModel {
    this.cols = value;
    return this;
  }

  setCustomSetup(value: CustomCompanySetupEnum): CTConfigurationModel {
    this.customCompanySetup = value;
    return this;
  }
  setDoubleClickOpenDetail(value: boolean): CTConfigurationModel {
    this.doubleClickOpenDetail = value;
    return this;
  }

  setExpanded(value: boolean): CTConfigurationModel {

    this.expanded = value;
    return this;

  }

  setLegendsItem(value: Array<any>): CTConfigurationModel {

    this.legendsItem = value;
    return this;

  }

}
